import { Component } from '@angular/core'
import { MatDialogContent } from '@angular/material/dialog'

@Component({
	selector: 'dialog-container',
	templateUrl: './Dialog.Component.html',
	imports: [MatDialogContent],
})
export class DialogComponent {}
